import createClass from 'create-react-class'
import Map from 'ol/Map'
import { unByKey } from 'ol/Observable'
import Overlay from 'ol/Overlay'
import PropTypes from 'prop-types'
import React from 'react'
import ReactDOM from 'react-dom'
import DtoStation from '../../station/dto/DtoStation'
import PopupContent from './PopupContent'
import { getClusterFeatures } from './MapCluster'

export default createClass({

    getDefaultProps() {
        return {
            olMap: {},
            event: {},
            layers: [],
            popupProps: { filters: [] },
        }
    },
    getInitialState() {
        return {
            feature: [],
            isPopupOpened: false,
        }
    },
    componentDidMount() {
        const container = ReactDOM.findDOMNode(this.refs.popup)
        this.popup = new Overlay({
            positioning: 'bottom-center',
            autoPan: true,
            autoPanAnimation: {
                duration: 250,
            },
            offset: [0, -5],
        })
        this.props.olMap.addOverlay(this.popup)
        this.popup.setElement(container)
        this.pointerMoveKey = this.props.olMap.on('pointermove', this.onPointerMove)
    },

    componentWillUnmount() {
        unByKey(this.pointerMoveKey)
        this.props.olMap.removeOverlay?.(this.popup)
    },

    onPointerMove(evt) {
        if (this.state.isPopupOpened) {
            return
        }
        const featuresOnHover = []
        let isOnCluster = false
        this.props.olMap.forEachFeatureAtPixel(evt.pixel, feature => {
            if (getClusterFeatures(feature)) {
                isOnCluster = true
            } else if (feature.getProperties().hover === true) {
                featuresOnHover.push(feature)
            }
        })
        if (!isOnCluster && featuresOnHover.length > 0) {
            const currentIds = this.state.feature.map(f => f.getId()).join('|')
            if (featuresOnHover.map(f => f.getId()).join('|') !== currentIds) {
                this.setState({ feature: featuresOnHover })
            }
            this.popup.setPosition(evt.coordinate)
        } else {
            this.popup.setPosition(undefined)
        }
    },

    componentWillReceiveProps(nextProps) {
        const arr = []
        const popup = this.popup
        const eventPixel = this.props.olMap.getEventPixel(nextProps.event)
        const clusterFeatures = nextProps.olMap.forEachFeatureAtPixel(eventPixel, feature => getClusterFeatures(feature))
        if (clusterFeatures) {
            if (nextProps.event !== this.props.event) {
                nextProps.onClusterClick?.(clusterFeatures)
            }
            this.setState({ isPopupOpened: false })
            popup.setPosition(undefined)
            return
        }
        nextProps.olMap.forEachFeatureAtPixel(eventPixel, feature => {
            const havePopup = (() => {
                const layer = this.props.layers.find(la => la.checkUuid(feature.getId()))
                if (layer) {
                    return layer.getPopup()
                }
                return null
            })
            const isOnFilter = this.props.popupProps.filters.includes(feature.getGeometry().getType())
            if (havePopup && isOnFilter) {
                arr.push(feature)
            }
        })
        if (arr.length > 0) {
            this.setState({ feature: arr, isPopupOpened: true })
            popup.setPosition(this.props.olMap.getCoordinateFromPixel(this.props.olMap.getEventPixel(nextProps.event)))
        } else {
            this.setState({ isPopupOpened: false })
            popup.setPosition(undefined)
        }
    },

    getContent() {
        if (this.state.feature.length > 0) {
            const filterLayers = this.state.feature.map(ft => this.props.layers.find(la => la.checkUuid(ft.getId())))
            return (
                <PopupContent
                    features={ this.state.feature }
                    layers={ filterLayers }
                    hover={ this.state.isPopupOpened }
                    currentStation={ this.props.currentStation }
                    getStation={ this.props.getStation }
                />
            )
        }
        return []
    },

    render() {
        const { popupStyle } = this.props
        return (
            <div ref='popup' style={popupStyle}>
                { this.getContent() }
            </div>
        )
    },

    propTypes: {
        olMap: PropTypes.instanceOf(Map),
        event: PropTypes.shape({ clientX: PropTypes.number, clientY: PropTypes.number }),
        layers: PropTypes.arrayOf(PropTypes.object),
        popupProps: PropTypes.shape({ filters: PropTypes.arrayOf(PropTypes.string) }),
        popupStyle: PropTypes.shape({}),
        currentStation: PropTypes.instanceOf(DtoStation),
        getStation: PropTypes.func,
        onClusterClick: PropTypes.func,
    },
})
